import { apiFetch } from '@/shared/api/client'

/** Satu baris stok bahan baku gudang — §3.1 warehouse-gudang-api.md. */
export type MaterialStockItem = {
  material_id: string
  material_code: string
  material_name: string
  packaging?: string
  pack_size?: number
  uom: string
  quantity_on_hand: number
  category_id?: string
  category_name?: string
}

type StockResponse = { items: MaterialStockItem[] }

/** GET /warehouse/material-stock — stok on-hand di warehouse_main device. */
export async function fetchMaterialStock(query?: string): Promise<MaterialStockItem[]> {
  const q = query?.trim()
  const qs = q ? `?q=${encodeURIComponent(q)}` : ''
  const res = await apiFetch<StockResponse>(`/warehouse/material-stock${qs}`)
  return res.items ?? []
}
